import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import StarredContentMenuQuery, {
	type StarredContentMenuQuery$data,
	type StarredContentMenuQuery$variables,
} from './__generated__/StarredContentMenuQuery.graphql.ts';
import { starredContentMenuQueryVars } from './starredContentMenuConstants.ts';
import type { GraphQLError } from 'graphql';

export function preloadStarredContentMenu(): Promise<{
	data: StarredContentMenuQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<StarredContentMenuQuery$data, StarredContentMenuQuery$variables>({
		query: StarredContentMenuQuery,
		variables: starredContentMenuQueryVars,
		fetchPolicy: 'network-only',
	});
}
